import React, { useState, useEffect } from "react";
import loginBg from "../../asset/login bg.png";
import logo from "../../asset/logo.svg";
import OTPInput from "react-otp-input";
import { NavLink, useNavigate } from "react-router-dom";
import {
  useLoginWithCodeMutation,
  useSendLoginCodeMutation,
} from "../../redux/userApi";
import { useParams } from "react-router-dom";
import { selectSuccess, selectUser, setProfile } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ButtonLoading from "../../Component/Button loading/ButtonLoading";
import { showErrorToast } from "../../utils/Utils";

const LoginCode = () => {
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [loginWithCode, { isLoading }] = useLoginWithCodeMutation();
  const [sendLoginCode, { isLoading: resendLoading }] =
    useSendLoginCodeMutation();
  const { email } = useParams();
  const user = useSelector(selectUser);
  const isSuccess = useSelector(selectSuccess);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    if (!otp.trim()) {
      newErrors.otp = "Login Code is required";
      isValid = false;
    } else if (otp.length < 6) {
      newErrors.otp = "Please fill the complete login code";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await loginWithCode({
        email,
        loginCode: { otp },
      }).unwrap();

      if (response.success) {
        toast.success(response.message);
        dispatch(setProfile(response.user));
      }
    } catch (err) {
      console.error("Login error:", err);
      showErrorToast(err);
    }
  };

  const [inputStyle, setInputStyle] = useState({
    width: "52px",
    height: "52px",
    border: "1px solid #33333360",
    color: "#33333390",
    borderRadius: "13px",
    fontSize: "20px",
    textAlign: "center",
    outline: "none",
  });

  useEffect(() => {
    const updateInputStyle = () => {
      if (window.innerWidth < 640) {
        setInputStyle((prev) => ({
          ...prev,
          width: "40px",
          height: "40px",
          fontSize: "16px",
        }));
      } else {
        setInputStyle((prev) => ({
          ...prev,
          width: "52px",
          height: "52px",
          fontSize: "20px",
        }));
      }
    };

    updateInputStyle();
    window.addEventListener("resize", updateInputStyle);

    return () => window.removeEventListener("resize", updateInputStyle);
  }, []);

  const resendCode = async (email) => {
    try {
      const response = await sendLoginCode(email).unwrap();

      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("code send error:", err);
      showErrorToast(err);
    }
  };

  useEffect(() => {
    if (isSuccess && user) {
      navigate("/banners");
    }
  }, [isSuccess, user, navigate]);
  return (
    <div className=" w-full h-screen relative">
      <img src={loginBg} className="w-full h-full  object-fill" alt="" />
      <div className=" absolute h-screen bg-white p-8 2xl:w-[35%] xl:w-[38%] lg:w-[43%] md:w-[50%] sm:w-[65%] w-full top-0 right-0 sm:rounded-s-2xl flex flex-col gap-4 items-center justify-center">
        <img src={logo} className="w-28" alt="" />
        <span className="text-[1.8rem] text-center text-[#333333] font-semibold">
          Welcome BacK!
        </span>
        <span className="text-[1rem] text-center text-[#333333]">
          Please enter the 6-digit code
        </span>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 items-center justify-center w-[90%]"
        >
          <div className="flex flex-col gap-1">
            <div className="flex justify-center items-center ">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputStyle={inputStyle}
                renderSeparator={<span className="mx-1" />}
                renderInput={(props) => <input {...props} />}
              />
            </div>
            {errors.otp && <p className="text-sm text-red-500">{errors.otp}</p>}
          </div>
          <div className="text-center text-[1rem] text-[#333333] font-medium">
            Didn’t get a code?{" "}
            <NavLink
              onClick={() => resendCode(email)}
              disabled={resendLoading}
              className={`text-[#00643b] ${
                resendLoading ? "cursor-not-allowed opacity-50" : ""
              }`}
            >
              {resendLoading ? "Resending..." : "Resend"}
            </NavLink>
          </div>

          <button
            type="Submit"
            disabled={isLoading}
            className="w-full p-3  bg-[#00643b] rounded-full font-medium text-white flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? <ButtonLoading text="Logging in..." /> : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginCode;
